import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Building2, LogOut } from 'lucide-react'
import { useAuth } from '@/features/auth'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { Logo } from '@/components/Logo'

export const Route = createFileRoute('/no-organization')({
  component: NoOrganizationPage,
})

function NoOrganizationPage() {
  useDocumentTitle('Sem Organização')
  const { signOut } = useAuth()

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/50">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <Logo size={56} />
          </div>
          <Building2 className="mx-auto h-12 w-12 text-muted-foreground" />
          <CardTitle className="text-2xl">Sem Organização</CardTitle>
          <CardDescription>
            Sua conta não está vinculada a nenhuma organização. Entre em contato com o administrador.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button onClick={signOut} variant="outline" className="w-full">
            <LogOut className="mr-2 h-4 w-4" />
            Sair
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
